import { CSSProperties, FC } from "react";
import { Link } from "react-router-dom";
import { formatNumberWithSuffix, roundToTwoDecimals } from "../../../../common/Number";
import { ReactComponent as InsightsGradient } from "../../../../assets/icons/svg/insights-gradient.svg";
import { VendorIntelligence, VendorIntelligenceProps } from "./VendorIntelligence";
import { DealScoreBar, DealScoreBarProps } from "./DealScoreBar";
import { Toolbox, ToolboxProps } from "./ToolBox";
import classes from "./Insights.module.less";

interface InsightsProps {
    name?: string;
    savings?: number;
    orderFormId?: number;
    vendorProps?: VendorIntelligenceProps;
    scoreBarProps?: DealScoreBarProps;
    toolboxProps?: ToolboxProps;
    style?: CSSProperties;
}

export const Insights: FC<InsightsProps> = ({
    name,
    savings = 0,
    orderFormId,
    vendorProps,
    scoreBarProps,
    toolboxProps,
    style,
}) => {
    const improveScore = roundToTwoDecimals(
        (scoreBarProps?.perfectScore ?? 90) - Number(scoreBarProps?.score)
    );
    return (
        <div className={classes.container} style={style}>
            <div className={classes.basic}>
                <div className={classes.titleRow}>
                    <InsightsGradient />
                    <span>
                        <span className={classes.label}>Insights</span>
                        <span className={classes.dot}> • </span>
                        {name}
                    </span>
                    <Toolbox className={classes.tools} {...toolboxProps} />
                </div>
                {improveScore <= 0 ? (
                    <div className={classes.savingsRow}>Your deal is already optimized.</div>
                ) : (
                    <div className={classes.savingsRow}>
                        Your deal has potential to improve by{" "}
                        <span className={classes.improve}>{improveScore}%</span>, estimating savings
                        of{" "}
                        <Link to={`/order/${orderFormId}`} className={classes.money}>
                            ${formatNumberWithSuffix(savings)}
                        </Link>
                        .
                    </div>
                )}
                <DealScoreBar {...scoreBarProps} />
            </div>
            <div className={classes.vendor}>
                <div className={classes.subtitleRow}>Vendor Intelligence</div>
                <VendorIntelligence {...vendorProps} />
            </div>
        </div>
    );
};
